export default __webpack_public_path__ + "static/Tek_Transmitter-db376d794d709a72e6ea7ca344cc9b48.png";